export const TABLE_HEADER_HEIGHT = '84px'
export const TABLE_HEADER_AND_CONTENT_GAP = '40px'
export const TABS_BOTTOM_MARGIN = '16px'
